<template>
  <div class="rooms">
    <span id="r-add-up">
      <RoomsAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('rooms.cards.title')">
      <template slot="actions">
        <va-popover :message="`${$t('rooms.tooltips.order')}`" placement="bottom">
          <va-button
            color="gray"
            icon="fa fa-list-ul"
            :to="{ name: 'rooms-order'}"
          />
        </va-popover>
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#r-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="rooms"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('rooms.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#r-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('rooms.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import RoomsAddUpdate from './RoomsAddUpdate'

const perPage = 10
export default {
  name: 'rooms',
  components: {
    RoomsAddUpdate,
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.rooms.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_room_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      rooms: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    rooms: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        rooms: room(limit: $perPage, offset: $page, order_by: {order: asc}) {
          id
          name
          paid
          active
          order
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: room_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'order',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('rooms.headings.name'),
        width: '50%',
      }, {
        name: 'paid',
        title: this.$t('rooms.headings.paid'),
        width: '10%',
        callback (value) {
          return value ? 'Sim' : 'Não'
        },
      }, {
        name: 'active',
        title: this.$t('rooms.headings.active'),
        width: '10%',
        callback (value) {
          return value ? 'Sim' : 'Não'
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('rooms')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.rooms.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
